"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpProfileOrders = void 0;
const App_1 = require("../App");
const tmpls_1 = require("./tmpls");
const CmpProfileOrdersItem_1 = require("./CmpProfileOrdersItem");
class CmpProfileOrders extends tmpls_1.CmpProfileOrdersBase {
    constructor() {
        super();
        this._skip = 0;
        const ctrl = this.ctrls;
    }
    loadAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const take = 20;
            const ctrl = this.ctrls;
            const orders = yield App_1.App.Inst.gui.lockAction(App_1.App.Inst.api.businessService.getMyOrders(this._skip, take));
            for (const order of orders) {
                const item = new CmpProfileOrdersItem_1.CmpProfileOrdersItem();
                item.fillAsync(order);
                ctrl.listOrders.append(item);
            }
        });
    }
}
exports.CmpProfileOrders = CmpProfileOrders;
//# sourceMappingURL=CmpProfileOrders.js.map